var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.8484,
    cy: 23.775,
    r: 21.8327,
    fill: "white",
    stroke: "#3333FF",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8492_10572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4473 18.4312C19.4473 19.462 19.8567 20.4505 20.5856 21.1793C21.3144 21.9082 22.3029 22.3176 23.3337 22.3176C24.3644 22.3176 25.353 21.9082 26.0818 21.1793C26.8107 20.4505 27.2201 19.462 27.2201 18.4312C27.2201 17.4005 26.8107 16.4119 26.0818 15.6831C25.353 14.9542 24.3644 14.5448 23.3337 14.5448C22.3029 14.5448 21.3144 14.9542 20.5856 15.6831C19.8567 16.4119 19.4473 17.4005 19.4473 18.4312Z",
    stroke: "#3333FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5049 32.0337V30.0905C17.5049 29.0597 17.9143 28.0712 18.6432 27.3424C19.372 26.6135 20.3606 26.2041 21.3913 26.2041H25.2777C26.3085 26.2041 27.297 26.6135 28.0258 27.3424C28.7547 28.0712 29.1642 29.0597 29.1642 30.0905V32.0337",
    stroke: "#3333FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8492_10572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3185,
    height: 23.3185,
    fill: "white",
    transform: "translate(11.6748 11.63)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagement);
export default __webpack_public_path__ + "static/media/management.2641fcd93727523fbfb40a7b228e05d5.svg";
export { ForwardRef as ReactComponent };